import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

export const PlaidAccountLinkTokenForUpgrade = gql`
  mutation PlaidAccountLinkTokenForUpgrade(
    $input: PlaidAccountLinkTokenForUpgradeInput!
  ) {
    plaidAccountLinkTokenForUpgrade(input: $input) {
      __typename
      ... on PlaidAccountLinkToken {
        linkToken
        expirationDate
        linkReferenceId
      }
      ... on PlaidAccountLinkTokenForUpgradeError {
        ...error
      }
    }
  }
  ${error}
`;
